import React from "react";

const CardAdmin = ({ children, className }) => {
    return (
        <div
            className={` ${className} bg-[#252526] p-4  border-[1px] border-[#3E3E42] rounded-xl`}
        >
            {children}
        </div>
    );
};

export default CardAdmin;
